// "One thing worth knowing": steps through the tips; today's tip is
// server-rendered, the date is rendered in the visitor's locale.
import { $, readJSON } from "./dom.js";
import { swapIn } from "../motion.js";

export function initAdvice() {
  const payload = readJSON(".js-advice-data");
  const text = $(".js-advice-text");
  if (!payload || !payload.tips.length || !text) return;

  const { tips } = payload;
  let index = payload.start || 0;

  const date = $(".js-advice-date");
  if (date) date.textContent = new Date().toLocaleDateString(document.documentElement.lang || "en-US", { weekday: "long", month: "long", day: "numeric" });

  const render = () => {
    const tip = tips[index];
    const country = $(".js-advice-country");
    country.textContent = "";
    const name = document.createElement("span");
    name.textContent = tip.c;
    const flag = document.createElement("span");
    flag.className = "advice__flag";
    flag.textContent = tip.f;
    country.append(name, flag);
    text.textContent = "“" + tip.t + "”";
    $(".js-advice-index").textContent = index + 1;
  };
  const step = (dir) => {
    index = (index + dir + tips.length) % tips.length;
    render();
    swapIn([$(".js-advice-country"), text], { y: 18, stagger: 0.07, duration: 0.5 });
  };

  $(".js-advice-prev").addEventListener("click", () => step(-1));
  $(".js-advice-next").addEventListener("click", () => step(1));
}
